import { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react';
import VisualizationManager from '@sas-dvr/ltjs-commons/VisualizationManager';
import { useSyncAppThemeImpl } from './__internal__';

// Visualization relies on the sas-icons declaration from Icon.css
import '@sas/nova-commons/components/Icon/Icon.css';

// Put this on the window for in case we get two instances of the module
// due to a version mismatch at package resolution time.
import { jsx as _jsx } from "react/jsx-runtime";
window.sas = window.sas || {};
window.sas.ltjs = window.sas.ltjs || {};
window.sas.ltjs.nextVisualizationId = window.sas.ltjs.nextVisualizationId || 0;
function uniqueId() {
  return `visualization_id_${window.sas.ltjs.nextVisualizationId++}`;
}
export const Visualization = /*#__PURE__*/forwardRef(function Visualization({
  syncAppTheme = true,
  applyAppTheme = true,
  ...props
}, ref) {
  const [id] = useState(uniqueId);
  const refVisualizationManager = useRef();

  // Create VisualizationManager on mount
  useEffect(() => {
    const visualizationManager = new VisualizationManager();
    refVisualizationManager.current = visualizationManager;
    return () => {
      visualizationManager.destroy();
      refVisualizationManager.current = undefined;
    };
  }, []);

  // Sync props with VisualizationManager
  useEffect(() => {
    if (refVisualizationManager.current) {
      refVisualizationManager.current.setModel(props.model, {
        applyAppTheme
      });
      refVisualizationManager.current.setContainerId(id);
      refVisualizationManager.current.setTooltipsEnabled(!props.disableTooltips);
    }
  }, [id, props.model, props.disableTooltips, applyAppTheme]);

  // Update the global app theme
  useSyncAppThemeImpl({
    enabled: syncAppTheme
  });
  useImperativeHandle(ref, () => {
    return {
      getPickResults: (x, y, isGlobal, updateSelections) => {
        return refVisualizationManager.current.getPickResults(x, y, isGlobal, updateSelections);
      },
      id,
      _getVisualizationManager: () => refVisualizationManager.current
    };
  }, [id]);
  return /*#__PURE__*/_jsx("div", {
    tabIndex: 0,
    id: id,
    style: props.style,
    className: props.className
  });
});
//# sourceMappingURL=Visualization.js.map